<template>
  <AppsStockHome :stock="stock" :translate="translate" />
</template>


<script setup>

import { useTranslationStore } from "@/stores/translations";
const translationStore = useTranslationStore();
const translate = translationStore.translate;

const props = defineProps({
  stock: {
    type: [Object, Array],
    required: true,
  }
})

</script>